// Hero Slider Configuration
// ===========================
// This config controls the home page hero banner slider.
// 
// HOW TO UPDATE SLIDER IMAGES:
// 1. Upload your images to: /app/frontend/public/assets/hero/
// 2. Update the 'slides' array below with your image filenames
// 3. Set captions and order as needed
// 4. Redeploy to see changes
//
// SUPPORTED FORMATS: .jpg, .jpeg, .png, .webp
// RECOMMENDED SIZE: 1920x900 or higher (wide hero aspect ratio)

export const heroSlider = {
  // Auto-slide interval in milliseconds (5000 = 5 seconds)
  interval: 5000,
  
  // Slide configuration
  // type: 'local' = from /assets/hero/ folder
  // type: 'external' = from external URL
  slides: [
    {
      type: 'local',
      fileName: 'hero-1.jpg',
      alt: 'Transmission Tower Line Infrastructure',
      caption: 'Transmission Line Projects'
    },
    {
      type: 'local',
      fileName: 'hero-2.jpg',
      alt: '220kV Electrical Substation',
      caption: 'High Voltage Substation Projects'
    },
    {
      type: 'local',
      fileName: 'hero-4.jpg',
      alt: 'Monopole Erection Work',
      caption: 'Monopole Erection & Commissioning'
    },
    {
      type: 'local',
      fileName: 'hero-5.jpg',
      alt: 'Solar and Renewable Energy Infrastructure',
      caption: 'Renewable Energy Solutions'
    },
    {
      type: 'local',
      fileName: 'hero-6.png',
      alt: 'Engineers at MCC Switchgear in Industrial Plant',
      caption: 'Industrial Electrical Panel Solutions'
    },
  ]
};

// ============================================
// TO ADD YOUR OWN IMAGES:
// ============================================
// 
// Option 1: Local images (recommended)
// ------------------------------------
// 1. Upload image to /app/frontend/public/assets/hero/your-image.jpg
// 2. Add to slides array:
//    {
//      type: 'local',
//      fileName: 'your-image.jpg',
//      alt: 'Description of image',
//      caption: 'Optional caption text'
//    }
//
// Option 2: External URLs
// -----------------------
// Use images hosted elsewhere:
//    {
//      type: 'external',
//      url: 'https://example.com/image.jpg',
//      alt: 'Description of image',
//      caption: 'Optional caption text'
//    }
//
// TO CHANGE ORDER: Simply reorder the items in the slides array
// TO REMOVE IMAGE: Delete the corresponding entry from the slides array
// ============================================
